import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { isMacOs } from 'react-device-detect';
import { keyImages, keyWidths, macKeys } from '../documentShortcut';

interface ShortCutCategorieProperties {
  keyCode: string;
  help: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    key: {
      height: 48,
      background: theme.customPalette.surface.base1,
      color: theme.customPalette.surface.white1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      border: `1px solid ${theme.customPalette.surfaceAccent.onBase.shade4}`,
      fontSize: 12
    },
    primaryKey: {

    },
    combinationSign: {
      color: '#bbb', 
      margin: 8
    }
  }));


export const ShortCutKey = (props: ShortCutCategorieProperties) => {
  const { keyCode, help } = props;
  const [primary, ...modifiers] = keyCode.split(/__/).filter(Boolean);

  if (isMacOs && ['PageUp', 'PageDown'].includes(primary)) {
    modifiers.push('Fn');
  }

  const classes = useStyles();

  return (
    <>
      <p>{help}</p>

      <div className={classes.root}>
        {modifiers.map(m => {
          const key = isMacOs ? macKeys[m] || m : m;
          return (
            <>
              <div
                className={classes.key}
                style={{
                  width: keyWidths[key] || 48
                }}
              >
                {keyImages[key]
                  ? keyImages[key] + ' ' + key
                  : key}
              </div>
              <span className={classes.combinationSign}>+</span>
            </>
          );
        })}
        <div
          style={{
            width: keyWidths[primary] || 48,
          }}
          className={classes.key}
        >
          {keyImages[primary]
            ? keyImages[primary]
            : primary.replace(/(Key|Digit)/, '')}
        </div>
      </div>
    </>
  );
};